import { ObservableModelNode } from "../observable";
import {
  createImageUrlAutoFormField,
  type SpecsAutoFormFieldMetadataMap,
} from "../autoFormMetadata";
import {
  cloneValue,
  expectObject,
  readBoolean,
  readOptionalNumber,
  readString,
  splitKnown,
} from "../utils";

export class DecorationDisplayModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    listOrder: { label: "List order", fieldType: "number", allowNull: true },
    colorImgUrl: createImageUrlAutoFormField({ label: "Color image URL" }),
    hideSizeValue: { label: "Hide size value", fieldType: "boolean" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  listOrder!: number | null;
  colorImgUrl!: string;
  hideSizeValue!: boolean;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("listOrder", 0);
    this.defineObservableValue("colorImgUrl", "draft");
    this.defineObservableValue("hideSizeValue", false);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "decoration display");
    this.listOrder = readOptionalNumber(source, "listOrder");
    this.colorImgUrl = readString(source, "colorImgUrl");
    this.hideSizeValue = readBoolean(source, "hideSizeValue", false);
    this.extra = splitKnown(source, [
      "listOrder",
      "colorImgUrl",
      "hideSizeValue",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.listOrder !== null ? { listOrder: this.listOrder } : {}),
      ...(this.colorImgUrl ? { colorImgUrl: this.colorImgUrl } : {}),
      ...(this.hideSizeValue ? { hideSizeValue: true } : {}),
    };
  }
}
